import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'

const NotificationDrawerSkeleton = () => {
  return (
    <>
      <ul className="grid grid-cols-1 gap-16 md:gap-12 sm:gap-12">
        {Array.from({ length: 5 }).map((_, index) => (
          <CardSkeleton
            key={index}
            className="h-[136px] !w-full md:h-[131px] sm:h-[92px]"
          />
        ))}
      </ul>
      <ButtonSkeleton
        height={56}
        className="sticky bottom-40 mt-32 !w-full lg:bottom-24 md:mb-24 md:mt-auto sm:bottom-20 sm:mb-20 sm:!h-[48px]"
      />
    </>
  )
}

export { NotificationDrawerSkeleton }
